
import { defineComponent } from 'vue';
import { AppCard, AppButton, AppImageHolder } from '@/components';
import { useLiveopsDetail } from '@/modules/liveops/item/model/detail';
import { LiveopsOptions, LiveopsRewardType } from '@/modules/liveops/item/types';
import { formatDate, renderOption } from '@/common/utils/helpers';
import { ROUTE_NAME_LIVEOPS } from '@/modules/liveops/router';
import MilestoneTable from '@/modules/liveops/milestone/view/table.vue';
import LeaderboardTable from '@/modules/liveops/leaderboard/view/table.vue';

export default defineComponent({
    name: 'LiveopsDetail',
    components: { AppCard, AppButton, AppImageHolder, MilestoneTable, LeaderboardTable },
    setup() {
        const { model, actions } = useLiveopsDetail();

        return {
            model,
            actions,
            formatDate,
            renderOption,
            LiveopsOptions,
            LiveopsRewardType,
            ROUTE_NAME_LIVEOPS
        };
    }
});
